import { type JSXProps } from 'engine/index';
import { DropdownField, Form, SubmitButton, TextField, validator as V } from './FormComponents';
import { lateinit, toTitleCase } from 'shared/util';
import { FormGroup } from './FormGroup';
import { gameIds, GameLicenseSchema, type GameLicense, type User } from 'shared/modelTypes/index';
import { CheckCheck } from 'lucide-static';
import { showToast, Toast } from './Toast';
import { navigate } from 'engine/router';
import { rpc } from 'src/backend';

type GameLicenseCreateProps = {
	users: Record<string, string>;
} & JSXProps;

export class GameLicenseCreate extends Base.Component<GameLicenseCreateProps> {
	backLink: HTMLElement = lateinit;
	users = this.props.users || {};

	override render(): HTMLElement {
		const view: HTMLElement = (
			<div class="flex flex-col gap-3">
				<h2 class="text-gray-700 dark:text-gray-300">New Game License</h2>
				<div class="w-fit rounded-lg bg-white p-6 shadow-md dark:bg-gray-800">
					<Form schema={GameLicenseSchema} onSubmit={this.create.bind(this)} class="flex flex-col gap-6">
						<div class="flex flex-col gap-6">
							<FormGroup>
								<DropdownField
									name="kind"
									label="Game"
									validator={V(GameLicenseSchema._def.right.shape.kind)}
									options={gameIds.map((g) => ({ value: g, label: toTitleCase(g.replaceAll('-', ' ')) }))}
								/>
								<DropdownField
									name="userId"
									label="Game Master"
									validator={V(GameLicenseSchema._def.right.shape.userId)}
									options={Object.entries(this.users).map(([key, name]) => ({
										value: key,
										label: name,
									}))}
								/>
								<TextField
									name="code"
									label="Code"
									validator={V(GameLicenseSchema._def.right.shape.code)}
									placeholder="Code"
								/>
								<TextField
									name="name"
									label="Name"
									title="Give the license a name to differentiate between different licenses for the same game"
									optional
									validator={V(GameLicenseSchema._def.right.shape.name)}
									placeholder="Name"
								/>
							</FormGroup>
						</div>
						<SubmitButton>Create</SubmitButton>
					</Form>
				</div>
			</div>
		);
		return view;
	}

	async create(license: GameLicense) {
		this.view.style.pointerEvents = 'none';
		this.view.style.opacity = '0.6';
		const res = await rpc.createGameLicense.query(license);
		navigate(`/dashboard/licenses`);
		showToast(<Toast icon={CheckCheck} title="License created!" />, 3000);
	}
}
